import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const FeatureCarousel = ({
  cardData,
  currentSlide,
  handlePrev,
  handleNext,
  getPosition,
}) => (
  <section className="group-card-carousel-section">
    <div className="carousel-wrapper">
      <div className="carousel-text">
        <h2 className="carousel-heading">Explore Our Features</h2>
        <p className="carousel-description">
          Discover how our plug-n-play system makes learning Industry 4.0
          engaging and effective for students through hands-on experiences.
        </p>
        <div className="carousel-controls">
          <button
            onClick={handlePrev}
            className="arrow-button"
            aria-label="Previous slide"
          >
            <FaChevronLeft />
          </button>
          <button
            onClick={handleNext}
            className="arrow-button"
            aria-label="Next slide"
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
      <div className="carousel-image-area">
        <div className="carousel-image-triple">
          {cardData.map((card, index) => {
            const position = getPosition(index, currentSlide, cardData.length);
            return (
              <div
                key={`carousel-card-${index}`}
                className={`carousel-card ${position}`}
              >
                <img src={card.imageUrl} alt={card.title} />
                <h3>{card.title}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

export default FeatureCarousel;
